import { useHistory, useRouteMatch } from 'react-router-dom';
import { Box } from '@givebutter/primitives/box';
import { Button } from '@givebutter/primitives/button';
import { Separator } from '@givebutter/primitives/separator';
import { getContactFormQueryParams } from 'assets/js/pages/contacts/contactFormParams';
import { TruncatedText } from 'components/truncated-text';
import { EmptyData } from 'components/util';
import { useCurrentContact } from 'customHooks/useCurrentContact';

const ContactSocials = () => {
    const history = useHistory();
    const match = useRouteMatch();
    const { data: contact } = useCurrentContact();

    return (
        <Box className={'flex flex-col'}>
            <div className={'flex items-center justify-between px-6 py-4'}>
                <p className={'text-lg font-medium text-gray-900'}>Social Accounts</p>
                <Button
                    variant="none"
                    color="primary"
                    size="sm"
                    className="font-medium"
                    onClick={() =>
                        history.push({
                            pathname: `${match.url}/details/edit`,
                            search: getContactFormQueryParams({
                                only: ['social'],
                                autoFocus: 'websiteUrl',
                            }),
                        })
                    }
                >
                    Edit
                </Button>
            </div>
            <Separator />
            <div className={'grid grid-cols-12 gap-4 px-6 pb-6 pt-4'}>
                <div className={'col-span-12 sm:col-span-6'}>
                    <div className={'flex flex-col gap-1'}>
                        <p className={'text-sm text-gray-600'}>Website</p>
                        <TruncatedText>
                            <LinkOrEmpty maybeLink={contact.website_url} />
                        </TruncatedText>
                    </div>
                </div>
                <div className={'col-span-12 sm:col-span-6'}>
                    <div className={'flex flex-col gap-1'}>
                        <p className={'text-sm text-gray-600'}>Facebook</p>
                        <TruncatedText>
                            <LinkOrEmpty maybeLink={contact.facebook_url} />
                        </TruncatedText>
                    </div>
                </div>
                <div className={'col-span-12 sm:col-span-6'}>
                    <div className={'flex flex-col gap-1'}>
                        <p className={'text-sm text-gray-600'}>LinkedIn</p>
                        <TruncatedText>
                            <LinkOrEmpty maybeLink={contact.linkedin_url} />
                        </TruncatedText>
                    </div>
                </div>
                <div className={'col-span-12 sm:col-span-6'}>
                    <div className={'flex flex-col gap-1'}>
                        <p title="Twitter" className={'text-sm font-bold text-gray-600'}>
                            𝕏
                        </p>
                        <TruncatedText>
                            <LinkOrEmpty maybeLink={contact.twitter_url} />
                        </TruncatedText>
                    </div>
                </div>
            </div>
        </Box>
    );
};

interface LinkOrEmptyProps {
    maybeLink?: string | null;
}
const LinkOrEmpty = (props: LinkOrEmptyProps) => {
    const { maybeLink } = props;

    if (maybeLink) {
        return (
            <a
                href={maybeLink}
                className={'font-base font-medium leading-tight'}
                target={'_blank'}
                rel="noreferrer"
            >
                {maybeLink}
            </a>
        );
    }

    return <Empty />;
};

const Empty = () => {
    return <EmptyData className={'mt-1 self-start'} />;
};

export { ContactSocials };
